import { FC } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router'

import { Flex, Typography } from 'antd'

import { Title } from '../../components/text/Title'
import { VideoCard } from '../../components/video/VideoCard'

const data = [
  { id: { videoId: '2swDiqXz488' } },
  { id: { videoId: 'vf9QSHmi4LE' } },
  { id: { videoId: 'LsvugDuOpqE' } },
]

const LatestVideosList: FC<{ pageSize?: number }> = ({ pageSize = 3 }) => {
  // const { data } = useQuery({
  //   queryKey: ['videos'],
  //   queryFn: () => client.getLatestVideos({ pageSize }),
  // })
  return (
    <Flex vertical>
      <Flex vertical gap={4} style={{ padding: 24, height: 88 }}>
        <Title style={{ marginBottom: 0 }} level={4}>
          <FormattedMessage id={'home.videos.header'} />
        </Title>
        <Typography.Text>
          <Link to={`https://youtube.com/@tochkaGP`} rel={'nofollow noreferrer'} target={'_blank'}>
            <FormattedMessage id={'home.videos.link'} />
          </Link>
        </Typography.Text>
      </Flex>
      <Flex vertical gap={16}>
        {data?.slice(0, pageSize).map((it) => <VideoCard key={it.id.videoId} videoId={it.id.videoId} />)}
      </Flex>
    </Flex>
  )
}
export { LatestVideosList }
